import React from 'react'
import UseSMT from './UseSMT'
import Testmonial from './Testmonial'
import AdventureTourPackage from '../landingpage/AdventureTourPackage'

const PackageHome = () => {
  return (
    <>
      <AdventureTourPackage />
      <Testmonial />
      <UseSMT />

    </>
  )
}

export default PackageHome
